import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiStar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 64.0001,
			height: 64,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.5958 12.2005V21.0002M53.9956 16.6003H45.1958M14.3966 42.9997V47.3996M16.5966 45.1996H12.1967M27.4576 39.6998C27.2612 38.9385 26.8644 38.2437 26.3084 37.6877C25.7524 37.1317 25.0576 36.7349 24.2963 36.5385L10.7996 33.0582C10.5694 32.9928 10.3667 32.8541 10.2224 32.6632C10.0781 32.4722 10 32.2394 10 32C10 31.7606 10.0781 31.5278 10.2224 31.3368C10.3667 31.1459 10.5694 31.0072 10.7996 30.9418L24.2963 27.4593C25.0574 27.2631 25.752 26.8666 26.3079 26.311C26.8639 25.7555 27.2609 25.0611 27.4576 24.3002L30.9379 10.8035C31.0026 10.5724 31.1412 10.3687 31.3324 10.2236C31.5237 10.0785 31.7571 10 31.9972 10C32.2373 10 32.4707 10.0785 32.662 10.2236C32.8532 10.3687 32.9918 10.5724 33.0565 10.8035L36.5346 24.3002C36.731 25.0615 37.1278 25.7563 37.6838 26.3123C38.2398 26.8683 38.9346 27.2651 39.6959 27.4615L53.1926 30.9396C53.4247 31.0036 53.6293 31.142 53.7752 31.3336C53.9211 31.5251 54.0001 31.7592 54.0001 32C54.0001 32.2408 53.9211 32.4749 53.7752 32.6664C53.6293 32.858 53.4247 32.9964 53.1926 33.0604L39.6959 36.5385C38.9346 36.7349 38.2398 37.1317 37.6838 37.6877C37.1278 38.2437 36.731 38.9385 36.5346 39.6998L33.0543 53.1965C32.9896 53.4276 32.851 53.6313 32.6598 53.7764C32.4685 53.9215 32.2351 54 31.995 54C31.7549 54 31.5215 53.9215 31.3302 53.7764C31.139 53.6313 31.0004 53.4276 30.9357 53.1965L27.4576 39.6998Z",
			stroke: "url(#paint0_linear_93_5949)",
			strokeWidth: 4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_93_5949",
			x1: 13.4539,
			y1: 20.4504,
			x2: 49.1807,
			y2: 49.6814,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .4375,
				stopColor: "#3C59F6"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .846154,
				stopColor: "#87BBFF"
			})]
		}) })
	]
});
export default SvgAiStar;
